<template>
    <div class="listmain ">
         <h1 class="firTitle">语音输出</h1>
              <p>OrionOS将提供将文本信息转换为语音信息的接口
              </p>
               <h5 class="thirdTitle">场景：</h5>
              <p>Q：放首歌
                <br>A：好的，为你播放刘德华的忘情水
                <br>"outSpeech": {
                <br>  "type": "text",
                <br>  "text": "好的，为你播放刘德华的忘情水"
                <br>  }
              </p>
              <p>注：ssml协议暂不支持。</p>

              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type : application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>
               <p>Response Body Syntax
              </p>
              <h5 class="codeTitle">语音输出</h5>
               <highlight-code lang="javascript">
                 "outSpeech": {//Type:JSONObject
                            "type": "text"//Type:String,输出的语音类型,取值类型：text、ssml
                            "text": "这是要转换成语音的文字"//Type:String,普通文本描述的语音文字
                            "textBGM":"http://*.mp3"//Type:String,普通文本背景音
                            "ssml": "SSML协议"//Type:String,SSML协议描述的语音文字
                }
              </highlight-code>


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_yysc.vue